import { AssetSvg } from '@/components/foundation/Svg'
import { Translation } from '@/components/foundation/Translation'
import { Button } from '@/components/ui/Button'
import { Modal } from '@/components/ui/Modal'
import { useTranslator } from '@/hooks/useTranslator'
import { getMapConfig } from '@/stores/config'
import { useSelector } from '@/stores/hooks'
import { useMap, useMapReady } from '@lc/libmap-react'
import { useRef, useState } from 'react'
import styles from './StyleSwitch.scss'

type StyleSwitchProps = {
	current: string
	onSwitch: (id: string, options: unknown) => void
}

export function StyleSwitch({ current, onSwitch }: StyleSwitchProps) {
	const mapConfig = useSelector(getMapConfig)
	const map = useMap()
	const mapReady = useMapReady()
	const [showOptions, setShowOptions] = useState(false)
	const translator = useTranslator()
	const containerRef = useRef<HTMLDivElement>(null)
	const buttonStyleSwitchRef = useRef<HTMLButtonElement | null>(null)

	if (!map || !mapReady) return null
	if (!mapConfig) return null

	const handleClickButton = () => {
		setShowOptions(prev => !prev)
	}
	const handleClose = () => {
		setShowOptions(false)
	}

	return (
		<div
			role="button"
			className={styles.switchContainer}
			ref={containerRef}
		>
			<Button
				ref={buttonStyleSwitchRef}
				rounded
				iconUrl="assets/MapOptionsStyleSwitch.svg"
				level="map-options-selector"
				onClick={handleClickButton}
				selected={showOptions}
			/>
			{showOptions && (
				<Modal
					onClose={handleClose}
					refToAlign={buttonStyleSwitchRef}
					mapOptionsModal
				>
					<div className={styles.titleContainer}>
						<AssetSvg
							name={'assets/Parameters.svg'}
							className={styles.titlePicto}
						/>
						<h3 className={styles.title}>
							<Translation id="map:options:modal-title" />
						</h3>
					</div>
					<div className={styles.listOptions}>
						{mapConfig.styles.map(style => {
							const isCurrent = style.id === current
							return (
								<Button
									key={style.id}
									onClick={() => {
										onSwitch(style.id, style.options)
									}}
									selected={isCurrent}
									imageUrl={`assets/MapOptions${style.id}.png`}
									iconClassName={styles.pictoOption}
									rounded
									label={translator.translate(
										`map:options:style-${style.id}`,
									)}
									level="map-option"
									disabled={isCurrent}
								/>
							)
						})}
					</div>
				</Modal>
			)}
		</div>
	)
}
